(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/react/components/progress-bar-container.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/react/components/progress-bar-container.js');

'use strict';

var _svs$lyckoplatsen$dat;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useMemo = _React.useMemo;
const ProgressBar = svs.numbergames.progress_bar.ProgressBar;
const isExaminedAtom = svs.lyckoplatsen.shared_mybets_wager.jotai.atoms.isExaminedAtom;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.shared_result.jotai.atoms,
  correctionStepAtom = _svs$lyckoplatsen$com.correctionStepAtom,
  correctionTriggerTypeAtom = _svs$lyckoplatsen$com.correctionTriggerTypeAtom,
  selectedResultAtom = _svs$lyckoplatsen$com.selectedResultAtom,
  isLatestResultAtom = _svs$lyckoplatsen$com.isLatestResultAtom,
  playCorrectionTlAtom = _svs$lyckoplatsen$com.playCorrectionTlAtom;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue,
  useAtom = _jotai.useAtom;
const _svs$lyckoplatsen$com2 = svs.lyckoplatsen.components.shared_constants.CONSTANTS,
  CORRECTION_STEP = _svs$lyckoplatsen$com2.CORRECTION_STEP,
  CORRECTION_TRIGGER_TYPE = _svs$lyckoplatsen$com2.CORRECTION_TRIGGER_TYPE;
const productMapping = svs.lyckoplatsen.components.shared_constants.productMapping;
const resultLatest = (_svs$lyckoplatsen$dat = svs.lyckoplatsen.data) === null || _svs$lyckoplatsen$dat === void 0 ? void 0 : _svs$lyckoplatsen$dat.result_latest;
const isSelfService = svs.core.config.data.svsconfig.isSelfService;
const indexStepMap = {
  48: {
    [CORRECTION_STEP.TOPWIN]: 0,
    [CORRECTION_STEP.PLACE]: 1,
    [CORRECTION_STEP.DISTANCE]: 2
  },
  49: {
    [CORRECTION_STEP.PLACE]: 0,
    [CORRECTION_STEP.DISTANCE]: 1
  }
};
const productName = 'lyckoplatsen';
const trackingCategory = 'result-lyckoplatsen';
const ProgressBarContainer = _ref => {
  let _ref$isResult = _ref.isResult,
    isResult = _ref$isResult === void 0 ? false : _ref$isResult;
  const result = useAtomValue(selectedResultAtom);
  const isExamined = useAtomValue(isExaminedAtom);
  const _useAtom = useAtom(isLatestResultAtom),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    isLatestResult = _useAtom2[0],
    setIsLatestResult = _useAtom2[1];
  const _useAtom3 = useAtom(correctionTriggerTypeAtom),
    _useAtom4 = _slicedToArray(_useAtom3, 2),
    correctionTriggerType = _useAtom4[0],
    setCorrectionTriggerType = _useAtom4[1];
  const _useAtom5 = useAtom(correctionStepAtom),
    _useAtom6 = _slicedToArray(_useAtom5, 2),
    correctionStep = _useAtom6[0],
    setCorrectionStep = _useAtom6[1];
  const _useAtom7 = useAtom(playCorrectionTlAtom),
    _useAtom8 = _slicedToArray(_useAtom7, 2),
    playCorrectionTl = _useAtom8[0],
    setPlayCorrectionTl = _useAtom8[1];
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    correctionTlStarted = _useState2[0],
    setCorrectionTlStarted = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    stepEnded = _useState4[0],
    setStepEnded = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    stepStarted = _useState6[0],
    setStepStarted = _useState6[1];
  const ref = useRef();
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    animationComplete = _useState8[0],
    setAnimationComplete = _useState8[1];
  const START_STEP = productMapping.isLyckoplatsenPrimary(result.productId) ? CORRECTION_STEP.TOPWIN : CORRECTION_STEP.PLACE;
  const allSteps = useMemo(() => {
    const steps = [{
      title: 'Plats',
      step: CORRECTION_STEP.PLACE
    }, {
      title: 'Avstånd',
      step: CORRECTION_STEP.DISTANCE
    }, {
      title: 'Resultat',
      step: CORRECTION_STEP.RESULT
    }];
    if (productMapping.isLyckoplatsenPrimary(result.productId)) {
      return [{
        title: 'Toppvinst',
        step: CORRECTION_STEP.TOPWIN
      }, ...steps];
    }
    return steps;
  }, [result]);
  const stepIndex = useMemo(() => {
    var _indexStepMap$result$, _indexStepMap$result$2;
    if (correctionStep === CORRECTION_STEP.RESULT) {
      return allSteps.length - 1;
    }
    return (_indexStepMap$result$ = (_indexStepMap$result$2 = indexStepMap[result.productId]) === null || _indexStepMap$result$2 === void 0 ? void 0 : _indexStepMap$result$2[correctionStep]) !== null && _indexStepMap$result$ !== void 0 ? _indexStepMap$result$ : 0;
  }, [correctionStep, result, allSteps]);
  const _useState9 = useState(stepIndex),
    _useState0 = _slicedToArray(_useState9, 2),
    activeStepIndex = _useState0[0],
    setActiveStepIndex = _useState0[1];
  const hide = useMemo(() => isResult ? isLatestResult && correctionStep === START_STEP && !correctionTlStarted : !isExamined && correctionStep === START_STEP && !correctionTlStarted, [isResult, isLatestResult, correctionStep, START_STEP, correctionTlStarted, isExamined]);
  useEffect(() => {
    setIsLatestResult(!isSelfService && result.drawNumber === (resultLatest === null || resultLatest === void 0 ? void 0 : resultLatest.drawNumber));
  }, [result.drawNumber, setIsLatestResult]);

  useEffect(() => {
    setCorrectionTriggerType(CORRECTION_TRIGGER_TYPE.CLICK);
  }, [result]);

  useEffect(() => {
    if ((stepIndex === 0 || stepIndex === allSteps.length - 1) && correctionTriggerType !== CORRECTION_TRIGGER_TYPE.AUTOMATED) {
      setActiveStepIndex(stepIndex);
    }
  }, [allSteps.length, correctionTriggerType, stepIndex, result]);
  useEffect(() => {
    if (playCorrectionTl && !correctionTlStarted) {
      setCorrectionTlStarted(true);
    }
  }, [playCorrectionTl, correctionTlStarted]);
  useEffect(() => {
    if (correctionStep === START_STEP || correctionStep === CORRECTION_STEP.RESULT) {
      setPlayCorrectionTl(false);
      setCorrectionTlStarted(false);
      setStepStarted(false);
    }
  }, [correctionStep, START_STEP, setPlayCorrectionTl]);
  useEffect(() => {
    if (correctionTlStarted) {
      setStepStarted(true);
    }
  }, [activeStepIndex, correctionTlStarted]);

  useEffect(() => {
    if (correctionTriggerType === CORRECTION_TRIGGER_TYPE.AUTOMATED && correctionTlStarted) {
      setStepStarted(false);
      setTimeout(() => {
        setStepEnded(true);
      }, 200);
    }
  }, [correctionStep, correctionTriggerType, correctionTlStarted, setCorrectionTriggerType]);
  useEffect(() => {
    if (hide) {
      gsap.set(ref.current, {
        opacity: 0,
        height: 0
      });
    } else {
      gsap.to(ref.current, {
        opacity: 1,
        height: 'auto',
        duration: 0.5
      });
    }
  }, [hide]);
  const handleStepClick = useCallback(stepIndex => {
    if (activeStepIndex === stepIndex) {
      return;
    }
    setCorrectionTriggerType(CORRECTION_TRIGGER_TYPE.CLICK);
    setActiveStepIndex(stepIndex);
    setCorrectionStep(allSteps[stepIndex].step);
    setStepEnded(false);
  }, [activeStepIndex, setCorrectionTriggerType, setCorrectionStep, allSteps]);

  useEffect(() => {
    if (animationComplete) {
      setActiveStepIndex(stepIndex);
      setStepEnded(false);
      setAnimationComplete(false);
    }
  }, [stepIndex, animationComplete, START_STEP, allSteps.length]);
  if (isSelfService) {
    return null;
  }
  return React.createElement("div", {
    className: "lp-progress-bar-container gsap-progress-bar-container ".concat(hide ? '--init-hide' : ''),
    ref: ref
  }, React.createElement(ProgressBar, {
    activeStepIndex: activeStepIndex,
    onStepClick: handleStepClick,
    productName: productName,
    steps: allSteps,
    trackingCategory: trackingCategory,
    duration: "1s",
    isActiveStepProgressComplete: stepEnded,
    isActiveStepProgressStarted: stepStarted,
    onProgressBarAnimationEnd: () => setAnimationComplete(true),
    displayShowDirect: false
  }));
};
Object.assign(svs.lyckoplatsen.components.shared_result.react.components, {
  ProgressBarContainer
});

 })(window);